import { Center, Loader, Stack, Text } from '@mantine/core';

interface ModuleLoadingSkeletonProps {
  moduleName?: string;
}

export function ModuleLoadingSkeleton({ moduleName }: ModuleLoadingSkeletonProps) {
  return (
    <Center h={256}>
      <Stack align="center" gap="md">
        <Loader size="lg" />
        <Text size="sm" c="dimmed">
          Loading {moduleName ? `${moduleName} module` : 'module'}...
        </Text>
      </Stack>
    </Center>
  );
}

export function FullScreenSpinner() {
  return (
    <Center h="100vh" w="100vw">
      <Loader size="lg" />
    </Center>
  );
}
